import cn from 'classnames';
import { memo, type ReactNode } from 'react';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
}

export const CommonButton = memo(
  ({ children, className, variant = 'primary', ...props }: Props) => {
    return (
      <button
        tabIndex={props.tabIndex}
        className={cn(st.button, st[variant], className)}
        {...props}
      >
        {children}
      </button>
    );
  }
);
